module.exports = {
	"articleTitle1": "Best Clothing Store: Bivouac ",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Bivouac",
	"articleLink2": "https://www.michigandaily.com/arts/best-outdoor-apparel-bivouac",
	"articleSnippet1": "Best Clothing Store: Bivouac . Jeremy Mitnick/Daily. Sarah Agnone. Daily Arts \nWriter. Sunday, April 2, 2017 - 10:43pm ...",
	"articleSnippet2": "Apr 11, 2012 ... It's no great surprise that Bivouac has topped the list again for best outdoor store. \nAs written in a recent Yelp review, “If you're an outdoor ...",
	"totalMisc": 1,
	"articleTitle2": "Best Outdoor Apparel: Bivouac",
	"address": "336 S State St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://magnify.michigandaily.us/best_of_ann_arbor_2017/images/jwy.NEW.BOAABivuocandMDen.4.1.17.017.jpg",
			"author": "File Photo",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.278175,
		"lng": -83.74104
	},
	"tips": [],
	"articleLink1": "#",
	"categories": {
		"clothingstore": 1,
		"bestofaa": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/bivouac.json
// module id = 828
// module chunks = 0